import React, { createContext, useContext, useState, ReactNode } from "react";

interface BillingAccessContextType {
  hasAccess?: boolean;
  isLoading: boolean;
  hasError: boolean;
  setBillingAccess: (
    hasAccess: boolean | undefined,
    isLoading: boolean,
    hasError?: boolean
  ) => void;
}

const BillingAccessContext = createContext<BillingAccessContextType>({
  hasAccess: undefined,
  isLoading: false,
  hasError: false,
  setBillingAccess: () => {},
});

interface BillingAccessProviderProps {
  children: ReactNode;
}

export const BillingAccessProvider: React.FC<BillingAccessProviderProps> = ({
  children,
}) => {
  const [hasAccess, setHasAccessState] = useState<boolean | undefined>(
    undefined
  );
  const [isLoading, setIsLoadingState] = useState<boolean>(false);
  const [hasError, setHasErrorState] = useState<boolean>(false);

  const setBillingAccess = (
    hasAccess: boolean | undefined,
    isLoading: boolean,
    hasError?: boolean
  ) => {
    setHasAccessState(hasAccess);
    setIsLoadingState(isLoading);
    setHasErrorState(hasError || false);
  };

  const contextValue: BillingAccessContextType = {
    hasAccess,
    isLoading,
    hasError,
    setBillingAccess,
  };

  return (
    <BillingAccessContext.Provider value={contextValue}>
      {children}
    </BillingAccessContext.Provider>
  );
};

export const useBillingAccess = () => {
  const context = useContext(BillingAccessContext);
  return context;
};
